import React, { useState } from 'react';
import '../../src/assets/css/SortingGameList.css';

const GameSorting = ({ onSort }) => {
  const [activeSort, setActiveSort] = useState('');

  const handleSort = (sortType) => {
    setActiveSort(sortType);
    onSort(sortType);
  };

  return (
    <div className="container d-flex justify-content-end" style={{    position: 'absolute'}}>
      <div className="custom-list-group p-3" style={{ background: 'white', boxShadow: 'rgba(96, 97, 112, 0.16) 0px 2px 4px 0px', borderRadius: '10px'}}>
        <button
          className={`custom-list-item ${activeSort === 'latestToEarliest' ? 'active' : ''}`}
          onClick={() => handleSort('latestToEarliest')}
        >
          Sort by Time - Latest to Earliest
        </button>
        <button
          className={`custom-list-item ${activeSort === 'earliestToLatest' ? 'active' : ''}`}
          onClick={() => handleSort('earliestToLatest')}
        >
          Sort by Time - Earliest to Latest
        </button>
        <button
          className={`custom-list-item ${activeSort === 'distanceNearToFar' ? 'active' : ''}`}
          onClick={() => handleSort('distanceNearToFar')}
        >
          Distance - Near to Far
        </button>
        <button
          className={`custom-list-item ${activeSort === 'distanceFarToNear' ? 'active' : ''}`}
          onClick={() => handleSort('distanceFarToNear')}
        >
          Distance - Far to Near
        </button>
      </div>
    </div>
  );
};

export default GameSorting;
